export default __webpack_public_path__ + "static/media/flag.09076c4b.svg";